module.exports = fox._r("images/logos/paradise_challenge.png", __webpack_public_path__ + "_/_/_/common/frame/images/logos/paradise_challenge.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/logos/paradise_challenge.png
// module id = 322
// module chunks = 2